import { webPortalApi } from '#config/web-portal-api';
import { FilterOption } from '#service/autocomplete-service/option';
import { getRequestOptions } from '#helper';

class DeviceTypeFilterOptionService {
  #searchFields;

  #cachedData;

  constructor(searchFields) {
    if (!searchFields?.length) {
      throw new Error('Search fields are not provided');
    }

    this.#searchFields = searchFields;
  }

  filterCachedData(filterStr) {
    return this.#cachedData.filter(o =>
      o.label.toLowerCase().includes(filterStr.toLowerCase()));
  }

  filterCachedDataByUID(ids) {
    const searchValues = ids.split(',');

    return this.#cachedData.filter(d => searchValues.includes(d.uid));
  }

  async fetchOptionsRaw(value, fetchOptions = {}, ids) {
    if (this.#cachedData) {
      if (value) {
        return this.filterCachedData(value);
      }

      if (ids) {
        return this.filterCachedDataByUID(ids);
      }

      return this.#cachedData;
    }

    const devicesURL = webPortalApi.buildApiUrl('meta/device');
    const res = await fetch(devicesURL, { ...getRequestOptions(), ...fetchOptions });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }

    const r = await res.json();

    if (!res.ok) {
      throw await r;
    }

    this.#cachedData = r;

    if (value) {
      return this.filterCachedData(value);
    }

    if (ids) {
      return this.filterCachedDataByUID(ids);
    }

    return r;
  }

  async getOptions(value, fetchOptions, ids) {
    const fetchedOptions = await this.fetchOptionsRaw(value, fetchOptions, ids);
    const transformedOptions = this.transformOptions(fetchedOptions);

    return transformedOptions;
  }

  transformOptions(options) {
    return options?.map(option => {
      const label = `${option.label}`;
      return new FilterOption(option, label);
    });
  }
}
export default DeviceTypeFilterOptionService;
